import produce from 'immer';

const INITIAL_STATE = {
  list: [],
  registry: {},
  loading: false,
  saving: false,
  error: false
};

export default function task(state = INITIAL_STATE, action) {
  switch (action.type) {
    case '@tasks/INDEX_REQUEST':
    case '@tasks/DELETE_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
      });

    case '@tasks/CREATE_REQUEST':
    case '@tasks/UPDATE_REQUEST':
    case '@tasks/UPDATE_SPRINT_REQUEST':
    case '@tasks/UPDATE_STATE_REQUEST':
      return produce(state, draft => {
        draft.saving = true;
        draft.error = false;
      });

    case '@tasks/READ_REQUEST':
      return produce(state, draft => {
        draft.loading = true;
        draft.error = false;
        draft.registry = {};
      });

    case '@tasks/CREATE_SUCCESS':
    case '@tasks/UPDATE_SUCCESS':
    case '@tasks/DELETE_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.saving = false;
      });

    case '@tasks/INDEX_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.list = action.payload.data;
      });

    case '@tasks/READ_SUCCESS':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = false;
        draft.registry = action.payload.data;
      });

    case '@tasks/INDEX_FAILURE':
    case '@tasks/CREATE_FAILURE':
    case '@tasks/UPDATE_FAILURE':
    case '@tasks/DELETE_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.saving = false;
      });

    case '@tasks/READ_FAILURE':
      return produce(state, draft => {
        draft.loading = false;
        draft.error = true;
        draft.registry = {};
      });

    default:
      return state;
  }
}
